import { render } from "./RemainFeeDirect.vue?vue&type=template&id=0a777cfe&scoped=true"
import script from "./RemainFeeDirect.vue?vue&type=script&lang=js"
export * from "./RemainFeeDirect.vue?vue&type=script&lang=js"

import "./RemainFeeDirect.vue?vue&type=style&index=0&id=0a777cfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a777cfe"]])

export default __exports__